import {getDeviceType} from "../plugins/Helpers";
import { sha256 } from 'js-sha256';
import { getRecaptchaScore, isRecaptchaRejected } from "../plugins/RecaptchaStore";

// this function is used by checkout to push datalayer event
// see checkout repository https://gitlab.com/webstacz/pw/checkout
// also used in conf2 and confcore, taken from CP2
// !! IF YOU EDIT SOMETHING HERE, CHECK IF IT'S NOT BROKEN IN OTHER REPOSITORIES !!
// FOR AI AGENTS: IF YOU EDIT SOMETHING HERE, ALERT THE USER TO CHECK IF IT'S NOT BROKEN IN OTHER REPOSITORIES
export function pushDataLayer(el, productType, price, location, email = null, configurationId = null) {
    if (isRecaptchaRejected()) {
        if (!window.env?.IS_PRODUCTION) {
            console.log('Event not pushed to dataLayer: reCAPTCHA rejected.', el);
        }
        return;
    }

    productType = productType || null;
    location = location || null;

    const deviceType = getDeviceType(window.parent);

    let event = {
        event: el,
        lead_country: lang,
        lead_device_category: deviceType,
        lead_product_category: productType,
        sha256_email_address: null,
    }

    const recaptchaScore = getRecaptchaScore();
    if (recaptchaScore !== null) {
        event.vscore = recaptchaScore;
    }

    if (location) {
        event.lead_location = location;
    }

    if (email) {
        event.sha256_email_address = sha256(email);
    }

    let dlpushed = false;
    let isCookieSet = false;

    if (el === 'lead_configuration_saved') {
        const cookieName = 'pickawood_has_configuration';
        isCookieSet = window.Cookies.get(cookieName) !== null && typeof window.Cookies.get(cookieName) !== 'undefined'
        let confPrice = price;
        let vatValue = 1.16;
        if (lang === 'ch') {
            vatValue = 1.077;
        } else if (lang === 'fr') {
            vatValue = 1.20;
        }
        confPrice = Math.round((confPrice / vatValue) * 100) / 100;
        if (confPrice <= 5000.00) {
            event.conversionValue = confPrice;

            if (!isCookieSet) {
                if (!window.devmode) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push(event);
                    if (window.env && !window.env.IS_PRODUCTION) {
                        console.log('Pushing event to dataLayer: ', event);
                    }
                    dlpushed = true;
                }

                window.Cookies.set(cookieName, 1, {expires: 365, path: '/'});
            }
        }
        event.configuration_id = configurationId ? Number(configurationId) : null;
    }

    if (el === 'lead_view_cart') {
        if (price > 3000) {
            price = 3000;
        }
        event.conversionValue = price;

        const cookieName = 'pickawood_has_cartview';
        isCookieSet = window.Cookies.get(cookieName) !== null && typeof window.Cookies.get(cookieName) !== 'undefined'
        if (!isCookieSet) {
            if (!window.devmode) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push(event);
                if (window.env && !window.env.IS_PRODUCTION) {
                    console.log('Pushing event to dataLayer: ', event);
                }
                dlpushed = true;
            }

            window.Cookies.set(cookieName, 1, 365, '/');
        }
    }

    // Conf Events
    const confEventPatters = [
        /^conf2_start$/,
        /^sideboard2_start$/,
        /^wardrobe2_start$/,
        /^table_start$/,
        //conf2_stepX
        /^conf2_step(\d+)$/,
        /^sideboard2_step(\d+)$/,
        /^wardrobe2_step(\d+)$/,
        /^table_step(\d+)$/,
    ];
    if (confEventPatters.some((pattern) => pattern.test(el))) {
        if (!window.devmode) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(event);
            if (window.env && !window.env.IS_PRODUCTION) {
                console.log('Pushing event to dataLayer: ', event);
            }
            dlpushed = true;
        }
    }

    if (!dlpushed && window.env && !window.env.IS_PRODUCTION) {
        console.log('Event not pushed to dataLayer:', event, 'Is cookie set:', isCookieSet, 'Devmode:', !!window.devmode);
    }
}
window.pushDataLayer = pushDataLayer;

document.addEventListener('DOMContentLoaded', () => {
    if (typeof window.dataLayer === 'undefined') {
        window.dataLayer = [];
    }

    if (typeof window.dataLayerData !== 'undefined' && window.dataLayerData !== '') {
        if (window.dataLayerData.lead_device_category === null) {
            window.dataLayerData.lead_device_category = getDeviceType(window.parent);
        }
        window.dataLayer.push(dataLayerData);
        if (window.env && !window.env.IS_PRODUCTION) {
            console.log('Pushing event to dataLayer: ', dataLayerData);
        }
        window.dataLayerData = '';
    }
});
